module.exports = __webpack_public_path__ + "img/6-volumes.577229a3.png";